// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const PRODUCCION = {
  mensaje: '¿Qué necesitas en Producción?',
  opciones: [
    {
      boton: 'Orden de producción',
      respuesta: 'Las órdenes de producción se crean en Producción → Órdenes. Define el artículo a producir, la cantidad y los insumos requeridos.',
    },
    {
      boton: 'Inventario de insumos',
      respuesta: 'Consulta los insumos disponibles en Producción → Inventario de insumos.',
    },
  ],
}
